import React, { useState, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const SnackbarAlert = ({
  open,
  message,
  severity,
  onClose,
  /** `null` disables auto-hide (e.g. blocking errors). Default 3000 ms. */
  autoHideDuration = 3000,
}) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setIsOpen(false);

    if (onClose) {
      onClose();
    }
  };

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <div>
        <Alert
          onClose={handleClose}
          severity={severity}
          sx={{ whiteSpace: "pre-line" }}
        >
          {message}
        </Alert>
      </div>
    </Snackbar>
  );
};

export default SnackbarAlert;
